export default __webpack_public_path__ + "static/media/popup.8ee7c74e.png";